import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '../../components/Typography';

const styles = theme => ({
  callUs: {
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.secondary.dark
    }
  }
});

class CallUs extends React.Component {
  render() {
    const { classes, primary, textProps } = this.props;
    let upper = primary;
    let color = primary ? 'primary' : 'secondary.dark';
    return (
      <Typography
        className={classes.callUs}
        component="a"
        href="tel:+18447686945"
        bold={true}
        upper={upper}
        variant="subtitle2"
        style={textProps}
        color={color}
      >
        Questions? Call us at 1-844-768-6945
      </Typography>
    );
  }
}

CallUs.defaultProps = {
  textProps: {}
};

CallUs.propTypes = {
  classes: PropTypes.object.isRequired,
  primary: PropTypes.bool.isRequired,
  textProps: PropTypes.object
};

export default withStyles(styles)(CallUs);
